var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { UsuarioService } from '../../services/usuario.service';
import { CommonService } from '../../services/common.service';
import { ReCaptchaComponent } from 'angular2-recaptcha';
var PopupRecaptcha = (function () {
    function PopupRecaptcha(_usrService, builder, _comService) {
        this._usrService = _usrService;
        this.builder = builder;
        this._comService = _comService;
        this.onClose = new EventEmitter(false);
        this.visible = false;
    }
    PopupRecaptcha.prototype.ngOnInit = function () {
        this.key = this._comService.dataSiteKey();
    };
    PopupRecaptcha.prototype.load = function () {
        this.visible = true;
    };
    PopupRecaptcha.prototype.close = function () {
        this.visible = false;
    };
    PopupRecaptcha.prototype.handleCorrectCaptcha = function (event) {
        try {
            document.getElementById("closeButton").click();
            this.captcha.reset();
        }
        catch (err) {
            //console.log(err); 
        }
    };
    PopupRecaptcha.prototype.finalize = function () {
        this.visible = false;
        this.onClose.emit(1);
    };
    return PopupRecaptcha;
}());
__decorate([
    Output(),
    __metadata("design:type", EventEmitter)
], PopupRecaptcha.prototype, "onClose", void 0);
__decorate([
    ViewChild(ReCaptchaComponent),
    __metadata("design:type", ReCaptchaComponent)
], PopupRecaptcha.prototype, "captcha", void 0);
__decorate([
    Input(),
    __metadata("design:type", String)
], PopupRecaptcha.prototype, "id", void 0);
PopupRecaptcha = __decorate([
    Component({
        moduleId: module.id,
        selector: 'popup-recaptcha',
        templateUrl: 'popup-recaptcha.html'
    }),
    __metadata("design:paramtypes", [UsuarioService,
        FormBuilder,
        CommonService])
], PopupRecaptcha);
export { PopupRecaptcha };
//# sourceMappingURL=popup-recaptcha.js.map